import { render, staticRenderFns } from "./listado_pedidos2.vue?vue&type=template&id=4f85fe7c&scoped=true"
import script from "./listado_pedidos2.vue?vue&type=script&lang=js"
export * from "./listado_pedidos2.vue?vue&type=script&lang=js"
import style0 from "./listado_pedidos2.vue?vue&type=style&index=0&id=4f85fe7c&prod&lang=scss&scoped=true"
import style1 from "./listado_pedidos2.vue?vue&type=style&index=1&id=4f85fe7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f85fe7c",
  null
  
)

export default component.exports